export enum ScreenMode {
  MOBILE_SMALL = 'MOBILE_SMALL',
  MOBILE_MEDIUM = 'MOBILE_MEDIUM',
  MOBILE_LARGE = 'MOBILE_LARGE',
  DESKTOP_SMALL = 'DESKTOP_SMALL',
  DESKTOP_MEDIUM = 'DESKTOP_MEDIUM',
  DESKTOP_LARGE = 'DESKTOP_LARGE',
  DESKTOP_EXTRA_LARGE = 'DESKTOP_EXTRA_LARGE'
}
